/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindProductSupplierContactValuesQueryResponse,
  FindProductSupplierContactValuesQueryParams,
} from "../types/FindProductSupplierContactValues.ts"

export const findProductSupplierContactValuesQueryKey = (
  params?: FindProductSupplierContactValuesQueryParams
) =>
  [
    { url: "/v1/product/find-product-supplier-contact-values" },
    ...(params ? [params] : []),
  ] as const

export type FindProductSupplierContactValuesQueryKey = ReturnType<
  typeof findProductSupplierContactValuesQueryKey
>

/**
 * @summary Find product supplier contact values
 * {@link /v1/product/find-product-supplier-contact-values}
 */
export async function findProductSupplierContactValues(
  params?: FindProductSupplierContactValuesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductSupplierContactValuesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-product-supplier-contact-values`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductSupplierContactValuesQueryOptions(
  params?: FindProductSupplierContactValuesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductSupplierContactValuesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductSupplierContactValuesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductSupplierContactValuesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductSupplierContactValues(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find product supplier contact values
 * {@link /v1/product/find-product-supplier-contact-values}
 */
export function useFindProductSupplierContactValues<
  TData = ResponseConfig<FindProductSupplierContactValuesQueryResponse>,
  TQueryData = ResponseConfig<FindProductSupplierContactValuesQueryResponse>,
  TQueryKey extends QueryKey = FindProductSupplierContactValuesQueryKey,
>(
  params?: FindProductSupplierContactValuesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductSupplierContactValuesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findProductSupplierContactValuesQueryKey(params)

  const query = useQuery(
    {
      ...findProductSupplierContactValuesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
